import type { InvestingTournament, InvestingTournamentAudience } from '@bloom/postgresql/entities/game/investing-tournament/investing-tournament.entity';

export type Tournament = InvestingTournament & {
  isParticipating?: boolean;
  portfolio?: any[] | any;
  institutionId?: string;
  collegeData?: any;
  audience: InvestingTournamentAudience;
};

export enum InvestingTournamentStatus {
  Inactive = 'Inactive',
  Open = 'Open',
  InProgress = 'InProgress',
  Finished = 'Finished',
  Cancelled = 'Cancelled',
}

export interface TournamentState {
  allTournaments: Tournament[];
  tournament: Tournament;
  tournamentGraphs: any;
  tournamentPortfolios: any;
  tournamentLeaderboards: any;
  shownTournamentIntro: boolean;
  homeTab: number;
} 

export interface ITournamentOverview {
  name?: string;
  label: string;
  value: string | number | Date;
  icon?: React.ReactNode | React.ReactElement;
}


export interface TournamentPickStokDto {
  symbol: string;
  allocatedNotional: number;
}
